import { FC, useState } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { isInViewFooterState, stepState, inquiryState } from '../../../states/messageState'
import { useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import styled from 'styled-components'
import { DatePicker } from '../../DatePicker'
import { Button } from '../../Button'
import { SendIcon } from '../../icons/SendIcon'
import { format } from 'date-fns'

export const InputDate: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()

  const [selectedDate, setSelectedDate] = useState<Date>(new Date())

  const setInquiry = useSetRecoilState(inquiryState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**日付選択 */
  const handleSubmitDate = async () => {
    setIsInViewFooter(false)
    const failureDateToMessage = format(selectedDate, 'yyyy年MM月dd日')
    const failureDateToRequest = format(selectedDate, 'yyyy-MM-dd')

    await handleAddSenderParent('user', failureDateToMessage)
    setInquiry((prev) => ({
      ...prev,
      failureDate: failureDateToRequest,
    }))

    await handleAddSenderParent('bot', `損傷の原因と製品の現在の状態を教えて下さい。`)
    handleInViewFooter()
    setCurrentStep('inputOverView')
  }

  return (
    <FooterContent isWide={false}>
      <StyledFlexWrap>
        <DatePicker selected={selectedDate} onChange={(date: Date) => setSelectedDate(date)} />
        <StyledSpace size={10} />
        <Button buttonType="icon" onClick={handleSubmitDate}>
          <SendIcon disabled={!selectedDate} />
        </Button>
      </StyledFlexWrap>
    </FooterContent>
  )
}

const StyledSpace = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: 1px;
`

const StyledFlexWrap = styled.div`
  display: flex;
`
